/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseUnitTypeModel>>;
export function request(
  body: defs.basics.BaseUnitTypeRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnitType/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
